import * as React from 'react'
import { Fab, Icon, Avatar, Menu, MenuItem } from '@material-ui/core'
import { Router } from 'routes'
import getConfig from 'next/config'
import { useTranslation } from 'i18n'
import { MenuProps } from '@material-ui/core/Menu'
import Link from 'next/link'
import { WithT } from 'i18next'
import { useCurrentUser } from 'utils/context/UserContext'

const {
  publicRuntimeConfig: { membershipOnly },
} = getConfig()

const Component = ({ onLogout, renderNoLogin = null, white = false }) => {
  const { t } = useTranslation('components')

  const [menuAnchor, setMenuAnchor] = React.useState(null)
  const { currentUser } = useCurrentUser()

  const openMenu = event => {
    setMenuAnchor(event.currentTarget)
  }

  const closeMenu = () => {
    setMenuAnchor(null)
  }

  const buttonProps = {
    style: { backgroundColor: white ? '#B0B0B0' : '#DEDEDE' },
    'aria-owns': menuAnchor ? 'accout-menu' : undefined,
    'aria-haspopup': true,
    onClick: openMenu,
  }

  if (currentUser)
    return (
      <div>
        <Fab size="small" {...buttonProps}>
          {currentUser?.photoURL ? (
            <Avatar src={currentUser.photoURL} />
          ) : (
            <Icon style={{ color: white ? 'white' : 'black' }}>person</Icon>
          )}
        </Fab>
        <UserMenu
          id="account-menu"
          anchorEl={menuAnchor}
          keepMounted
          open={!!menuAnchor}
          onClose={closeMenu}
          onLogout={onLogout}
          t={t}
        />
      </div>
    )

  return renderNoLogin ? (
    renderNoLogin
  ) : (
    <div>
      <Fab size="small" {...buttonProps}>
        <Icon style={{ color: white && 'white' }}>person</Icon>
      </Fab>
      <NoUserMenu
        id="account-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={!!menuAnchor}
        onClose={closeMenu}
        t={t}
      />
    </div>
  )
}

type UserMenuProps = {
  onLogout: (any) => void
} & MenuProps &
  WithT

const UserMenu = ({ onLogout, t, ...props }: UserMenuProps) => (
  <Menu {...props}>
    {!membershipOnly && (
      <MenuItem onClick={() => Router.pushRoute('portfolios')}>
        {t('Menu.Avatar.portfolio')}
      </MenuItem>
    )}
    <MenuItem onClick={() => Router.pushRoute('account')}>
      {t('Menu.Avatar.account')}
    </MenuItem>
    <Link href="/logout" passHref>
      <MenuItem component="a">{t('Menu.Avatar.logout')}</MenuItem>
    </Link>
  </Menu>
)

type NoUserMenuProps = {} & MenuProps & WithT

const NoUserMenu = ({ t, ...props }: NoUserMenuProps) => (
  <Menu {...props}>
    <MenuItem onClick={() => Router.pushRoute('login')}>
      {t('Menu.Avatar.login')}
    </MenuItem>
    <MenuItem onClick={() => Router.pushRoute('signup')}>
      {t('Menu.Avatar.memberRegistration')}
    </MenuItem>
  </Menu>
)

export default Component
